module.exports = __webpack_public_path__ + "static/media/home_bg.1a72f524.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/value-investment/home_bg.png
// module id = 794
// module chunks = 0